import styles from "./QR.module.css";

function Qr() {
  return <img src="/qr.png" className={styles.img} alt="Qr-image" />;
}

export default Qr;
